import React, { useState } from "react";
import MonthNavigator from "../Balanceview/MonthNavigator";
import Pay from "./Pay";

const Paysheet = ({ customerId }) => {
  const [currentDate, setCurrentDate] = useState(new Date());
  return (
    <>
      <div className="max-w-full mx-auto bg-white rounded-xl shadow p-4 space-y-4">
        <MonthNavigator date={currentDate} onChange={setCurrentDate} />

        <Pay currentDate={currentDate} customerId={customerId} />
      </div>
    </>
  );
};

export default Paysheet;
